<template>
  <el-table-column
    prop="end_date"
    sortable="custom"
    label="Leltározás befejezése"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      {{ scope.row.end_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'end_date',
  };
</script>
